export default "<div [ngStyle]=\"{'width': size, 'height': size}\" class=\"d-inline-flex align-items-center\" [innerHTML]=\"svg\"></div>\n";